// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__30ZEn","Label":"Input_Label__Zbrkh","InputElement":"Input_InputElement__2CVN1","Invalid":"Input_Invalid__E7FGj"};